import { useEffect } from "react";
// @ts-ignore
import $ from "jquery";
// @ts-ignore
import "summernote/dist/summernote-lite.min.css";
// @ts-ignore
import "summernote/dist/summernote-lite.min.js";

interface RichTextEditorProps {
  id: string;
  value: string;
  onChange: (html: string) => void;
  height?: number;
  placeholder?: string;
}

const RichTextEditor = ({
  id,
  value,
  onChange,
  height = 200,
  placeholder = "Nhập nội dung...",
}: RichTextEditorProps) => {
  useEffect(() => {
    const selector = `#${id}`;
    const $el = $(selector);
    if (!$el.length || $el.data("summernote")) return;

    $el.summernote({
      height,
      minHeight: 120,
      maxHeight: 500,
      focus: false,
      placeholder,
      toolbar: [
        ["style", ["style"]],
        ["font", ["bold", "italic", "underline", "strikethrough", "clear"]],
        ["fontname", ["fontname"]],
        ["fontsize", ["fontsize"]],
        ["color", ["color"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["table", ["table"]],
        ["insert", ["link", "picture"]],
        ["view", ["codeview", "help"]],
      ],
      styleTags: ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
      fontNames: ["Arial", "Times New Roman", "Georgia", "Verdana"],
      fontSizes: ["12", "14", "16", "18", "20", "24"],
      callbacks: {
        onInit: function () {
          if (value) $el.summernote("code", value);
        },
        onChange: function (contents: string) {
          onChange(contents);
        },
      },
    });

    return () => {
      if ($el.data("summernote")) $el.summernote("destroy");
    };
  }, [id]);

  useEffect(() => {
    const selector = `#${id}`;
    const $el = $(selector);
    if ($el.length && $el.data("summernote")) {
      try {
        const current = $el.summernote("code");
        if (current !== value) $el.summernote("code", value);
      } catch (_e) {
        // Summernote chưa sẵn sàng
      }
    }
  }, [id, value]);

  return (
    <div className="rich-text-editor-wrapper">
      <div id={id} className="summernote-editor" />
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .rich-text-editor-wrapper .note-editable {
              min-height: ${height}px;
            }
            .rich-text-editor-wrapper .note-editable p { margin-bottom: 0.5em; }
            .rich-text-editor-wrapper .note-editable strong { font-weight: 600; }
          `,
        }}
      />
    </div>
  );
};

export default RichTextEditor;
